// only these icons make it to the bundle
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye, faEyeSlash, faClone, faCheckSquare, faTrashAlt, faWindowRestore, faPlusSquare, faMinusSquare } from '@fortawesome/free-regular-svg-icons';
import { faImages, faSearchPlus, faSearch, faCog, faThList, faTimes, faCaretLeft, faCaretRight, faChevronUp, faChevronDown, faMap } from '@fortawesome/free-solid-svg-icons';

library.add(
  faEye,
  faEyeSlash,
  faCheckSquare,
  faClone,
  faImages,
  faSearchPlus,
  faSearch,
  faCog,
  faThList,
  faTrashAlt,
  faWindowRestore,
  faTimes,
  faPlusSquare,
  faMinusSquare,
  faCaretLeft,
  faCaretRight,
  faChevronUp,
  faChevronDown,
  faMap
);
